import { cn } from "@/lib/utils";
import { Skeleton } from "@/components/ui/skeleton";
import DropdownScrollDown from "@/components/views/quote-venue/steps/select-screen/select-service/scroll-down";
import { SearchOptionDataProps } from "@/components/views/modals/search/types";
import ChevronRightIcon from "@heroicons/react/24/outline/ChevronRightIcon";
import SwatchIcon from "@heroicons/react/24/outline/SwatchIcon";
import InfiniteScroll from "react-infinite-scroll-component";
import { Link } from "@/components/CustomLink";
import SearchDropdownWhiteScreen from "@/components/views/modals/search/dropdown/WhiteScreen";
import { useMemo } from "react";

interface Props {
  hasMore: boolean;
  setHasMore?: (value: boolean) => void;
  data: SearchOptionDataProps[];
  show: boolean;
  itemCount: number;
  large: string | undefined;
  loading: boolean;
  index: number;
  next: (page: number) => void;
  currentPage: number;
  setCurrentPage: (page: number) => void;
}

export default function SearchBlogDropdown(props: Props) {
  const { data, show, loading, index, currentPage, setCurrentPage, hasMore } =
    props;

  const showItems = useMemo(() => {
    return (
      <InfiniteScroll
        style={{
          overflowX: "hidden",
        }}
        height={360}
        next={() => {
          if (props.next) props.next(currentPage);
          setCurrentPage(currentPage + 1);
          // // If no more data is returned, set hasMore to false
          // if (data.length === props.itemCount && props.setHasMore) {
          //   props.setHasMore(false);
          // }
        }}
        hasMore={hasMore ?? false}
        dataLength={data.length || 0}
        className="min-w-full"
        loader={
          hasMore && (
            <div className="text-center text-primary font-bold">
              Yükleniyor...
            </div>
          )
        }
      >
        {data?.map((item, index) => {
          return (
            <Link
              href={`/blog/${item.slug}`}
              key={index}
              aria-disabled={false}
              className="py-4 cursor-pointer flex items-center justify-between border-b border-gray-200"
            >
              <div className="flex items-center gap-2 text-sm text-primary font-medium">
                <SwatchIcon className="size-4" />
                <div className="flex flex-col gap-1">
                  <div>{item.title}</div>
                </div>
              </div>

              <ChevronRightIcon className="text-primary size-4" />
            </Link>
          );
        })}
      </InfiniteScroll>
    );
  }, [props.data, hasMore, currentPage]);

  return (
    <SearchDropdownWhiteScreen show={show} index={index}>
      <div className="py-2 text-assistant font-bold text-[10px]">
        {loading ? 0 : props.itemCount} Sonuç Bulundu
      </div>

      <div className="md:flex hidden flex-col overflow-y-auto min-w-[290px] ">
        <div
          className={cn(
            props.large
              ? "w-full overflow-y-auto h-[390px]"
              : "relative h-[390px] overflow-y-auto",
          )}
        >
          {!loading && show && (
            <div className={`h-[386px] pb-10 overflow-y-auto`}>
                {showItems}
            </div>
          )}

          {loading && <ListItemsLoading />}
        </div>
      </div>

      <div className="md:hidden flex flex-col overflow-y-auto">
        <div
          className={cn(
            props.large
              ? "w-full overflow-y-auto"
              : "h-[calc(100dvh-200px)] overflow-y-auto relative",
          )}
        >
          {!loading && show && showItems}

          {loading && <ListItemsLoading />}
        </div>

        {data.length > 7 && <DropdownScrollDown />}
      </div>
    </SearchDropdownWhiteScreen>
  );
}

function ListItemsLoading() {
  return Array.from(Array(27).keys()).map((index: number) => {
    return (
      <div key={index} className="m-2">
        <Skeleton className="h-5 w-[250px]" />
      </div>
    );
  });
}
